import reactLogo from "../asset/stack/react.svg";
import nextLogo from "../asset/stack/next.svg";
import tailwindLogo from "../asset/stack/tailwind.svg";
import wordpressLogo from "../asset/stack/wordpress.svg";
import { Link } from "react-router-dom";

const Interests = () => {
  return (
    <section className=" flex px-6 border-[#7C6AE6] border-b-2   bg-neutral-white  overflow-hidden">
      <div className="relative mx-auto max-w-[1300px] ">

        {/* FLOATING STACK ICONS (DESKTOP / TABLET ONLY) */}
        <img
          src={reactLogo}
          alt="React"
          className=" block absolute top-[11%] left-[2%] lg:top-[8%] lg:left-[10%] w-8 opacity-70 rotate-[-8deg]"
        />

        <span className=" block absolute text-gray-400 top-[30%] left-[-4%] lg:top-[50%] lg:left-[14%] text-[18px] rotate-12">
          ✦
        </span>

        <img
          src={nextLogo}
          alt="Next.js"
          className="bottom-[4%] left-[2%] block absolute lg:bottom-[16%] lg:left-[20%] w-8  rotate-[12deg]"
        />

        <img
          src={tailwindLogo}
          alt="Tailwind CSS"
          className=" top-[20%] right-[2%] block absolute lg:top-[18%] lg:right-[-2%] w-8 rotate-[6deg]"
        />

        <img
          src={wordpressLogo}
          alt="WordPress"
          className="bottom-[14%] right-[2%] absolute lg:bottom-[10%]  lg:right-[6%] w-8 rotate-[6deg]"
        />

        {/* CONTENT WRAPPER */}
        <div className=" pb-24">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-[120px]">

            {/* CTA */}
            <Link
              to="/About"
              className="
                inline-flex items-center justify-center
                px-6 py-3 md:px-8 md:py-4
                text-sm md:text-base font-semibold tracking-wide
                bg-[#7C6AE6] text-white
                border-2 border-[#7C6AE6]
                hover:bg-black hover:text-[#E6D9FC]
                transition-colors duration-300
                shrink-0 rounded-md
              "
            >
              MORE ABOUT ME
            </Link>

            {/* TEXT CARD */}
            <div className="relative w-full   text-white md:px-[40px] pt-4  md:py-12 ">

              <span className="bottom-[20%] right-[2%] absolute lg:-top-1 lg:-right-[-8] text-[22px] opacity-30 rotate-12">
                ✦
              </span>

              <p className=" font-bold md:text-sm uppercase tracking-widest  md:text-[18px] leading-relaxed mt-6  mb-4 ">
                How I like to build
              </p>

              <p className="mt-5 text-base md:text-[18px] lg:text-[20px] italic font-light leading-relaxed opacity-80 ">
        I care about writing code that actually makes sense to come back to.
React and Next.js are my go-to for building things that scale, and
Tailwind keeps me moving fast without things falling apart.
              </p>

              <p className="mt-5 text-base md:text-[18px] lg:text-[20px] italic font-light leading-relaxed opacity-80 ">
                I work just as comfortably with WordPress when content management,flexibility, and ease of updates are essential
                
               
                <br/>
                <p className="mt-5 text-base md:text-[18px] lg:text-[20px] italic   font-semibold leading-relaxed opacity-80 ">  —Selecting the
                right tool based on the product’s goals, not personal bias. </p>
                
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Interests;
